import { render, staticRenderFns } from "./TaskLabelAttachedActivity.vue?vue&type=template&id=0944b2bf"
import script from "./TaskLabelAttachedActivity.vue?vue&type=script&lang=js"
export * from "./TaskLabelAttachedActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports